import { createFileRoute } from "@tanstack/react-router";
import Blog from "@/pages/Blog";
import { blogPostsQuery, safePrefetch } from "@/lib/publicQueries";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/")({
  loader: async ({ context }) => {
    await safePrefetch(context.queryClient, blogPostsQuery());
  },
  head: () =>
    seoHead({
      title: "Blog: Foto, Video und Social Media aus Mannheim | Clicks DMP",
      description:
        "Praxiswissen zu Videoproduktion, Fotografie und Social Media von Clicks DMP aus Mannheim.",
      path: "/blog",
    }),
  component: Blog,
});
